var _excluded = ["messages", "agentId"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AbstractChat } from 'ai';
export { AbstractChat };
export var CACHE_KEY = 'instantsearch-chat-initial-messages-';
function getDefaultInitialMessages(id) {
  var initialMessages = sessionStorage.getItem(CACHE_KEY + id);
  return initialMessages ? JSON.parse(initialMessages) : [];
}
export var ChatState = /*#__PURE__*/function () {
  function ChatState() {
    var _this = this;
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var initialMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultInitialMessages(id);
    _classCallCheck(this, ChatState);
    _defineProperty(this, "_messages", void 0);
    _defineProperty(this, "_status", 'ready');
    _defineProperty(this, "_error", undefined);
    _defineProperty(this, "_messagesCallbacks", new Set());
    _defineProperty(this, "_statusCallbacks", new Set());
    _defineProperty(this, "_errorCallbacks", new Set());
    _defineProperty(this, "pushMessage", function (message) {
      _this._messages = _this._messages.concat(message);
      _this._callMessagesCallbacks();
    });
    _defineProperty(this, "popMessage", function () {
      _this._messages = _this._messages.slice(0, -1);
      _this._callMessagesCallbacks();
    });
    _defineProperty(this, "replaceMessage", function (index, message) {
      _this._messages = [].concat(_toConsumableArray(_this._messages.slice(0, index)), [
      // We deep clone the message here to ensure the new React Compiler (currently in RC) detects deeply nested parts/metadata changes:
      _this.snapshot(message)], _toConsumableArray(_this._messages.slice(index + 1)));
      _this._callMessagesCallbacks();
    });
    _defineProperty(this, "snapshot", function (thing) {
      return JSON.parse(JSON.stringify(thing));
    });
    _defineProperty(this, '~registerMessagesCallback', function (onChange) {
      var callback = onChange;
      _this._messagesCallbacks.add(callback);
      return function () {
        _this._messagesCallbacks.delete(callback);
      };
    });
    _defineProperty(this, '~registerStatusCallback', function (onChange) {
      _this._statusCallbacks.add(onChange);
      return function () {
        _this._statusCallbacks.delete(onChange);
      };
    });
    _defineProperty(this, '~registerErrorCallback', function (onChange) {
      _this._errorCallbacks.add(onChange);
      return function () {
        _this._errorCallbacks.delete(onChange);
      };
    });
    _defineProperty(this, "_callMessagesCallbacks", function () {
      _this._messagesCallbacks.forEach(function (callback) {
        return callback();
      });
    });
    _defineProperty(this, "_callStatusCallbacks", function () {
      _this._statusCallbacks.forEach(function (callback) {
        return callback();
      });
    });
    _defineProperty(this, "_callErrorCallbacks", function () {
      _this._errorCallbacks.forEach(function (callback) {
        return callback();
      });
    });
    this._messages = initialMessages;
    var saveMessagesInLocalStorage = function saveMessagesInLocalStorage() {
      if (_this.status === 'ready') {
        try {
          sessionStorage.setItem(CACHE_KEY + id, JSON.stringify(_this.messages));
        } catch (e) {
          // Do nothing if sessionStorage is not available or full
        }
      }
    };
    this['~registerMessagesCallback'](saveMessagesInLocalStorage);
    this['~registerStatusCallback'](saveMessagesInLocalStorage);
  }
  _createClass(ChatState, [{
    key: "status",
    get: function get() {
      return this._status;
    },
    set: function set(newStatus) {
      this._status = newStatus;
      this._callStatusCallbacks();
    }
  }, {
    key: "error",
    get: function get() {
      return this._error;
    },
    set: function set(newError) {
      this._error = newError;
      this._callErrorCallbacks();
    }
  }, {
    key: "messages",
    get: function get() {
      return this._messages;
    },
    set: function set(newMessages) {
      this._messages = _toConsumableArray(newMessages);
      this._callMessagesCallbacks();
    }
  }]);
  return ChatState;
}();
export var Chat = /*#__PURE__*/function (_AbstractChat) {
  _inherits(Chat, _AbstractChat);
  var _super = _createSuper(Chat);
  function Chat(_ref) {
    var _this2;
    var messages = _ref.messages,
      agentId = _ref.agentId,
      init = _objectWithoutProperties(_ref, _excluded);
    _classCallCheck(this, Chat);
    var state = new ChatState(agentId, messages);
    _this2 = _super.call(this, _objectSpread(_objectSpread({}, init), {}, {
      state: state
    }));
    _defineProperty(_assertThisInitialized(_this2), "_state", void 0);
    _defineProperty(_assertThisInitialized(_this2), '~registerMessagesCallback', function (onChange) {
      return _this2._state['~registerMessagesCallback'](onChange);
    });
    _defineProperty(_assertThisInitialized(_this2), '~registerStatusCallback', function (onChange) {
      return _this2._state['~registerStatusCallback'](onChange);
    });
    _defineProperty(_assertThisInitialized(_this2), '~registerErrorCallback', function (onChange) {
      return _this2._state['~registerErrorCallback'](onChange);
    });
    _this2._state = state;
    return _this2;
  }
  return _createClass(Chat);
}(AbstractChat);